import React from "react";

const SectionSeparator = () => {
    return <div className="section__separator"></div>;
};

export default SectionSeparator;
